import React, { useContext, useEffect } from 'react';

import Context from '../../../contexts/docs';
import { Keys } from '../../../components/docs/types';

interface Props {
  children: any;
}

/**
 * Opt-in: add `data-suppress-docs-slash-search` on a wrapper so `/` does not
 * open the global docs search while focus is inside that subtree.
 */
const isGlobalSearchForwardSlashSuppressed = (target: EventTarget | null) => {
  if (!(target instanceof Element)) {
    return false;
  }
  return Boolean(target.closest('[data-suppress-docs-slash-search]'));
};

const KeypressWrapper = (props: Props) => {
  const { dispatch } = useContext(Context);

  const onEvent = (e: KeyboardEvent): any => {
    if (e.defaultPrevented) {
      return; // Do nothing if the event was already processed
    }

    const key = e.key as Keys;

    if (
      key === Keys.FORWARD_SLASH &&
      isGlobalSearchForwardSlashSuppressed(e.target)
    ) {
      return;
    }

    if (key === Keys.ESCAPE || key === Keys.FORWARD_SLASH) {
      dispatch({
        type: 'GLOBAL_KEY_PRESSED',
        payload: { key: key },
      });
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', onEvent);
    return () => window.removeEventListener('keydown', onEvent);
  });

  return props.children;
};

KeypressWrapper.displayName = 'KeypressWrapper';
export default KeypressWrapper;
